import * as React from "react";
import { Box } from "../box/box.component";
import {StyledPromotions} from "./promotion.style";
import {BRX_ASSETS_URL, calls, PROJECT_KEY, PROJECT_LANGUAGE} from "../../core/APIUtils";
import { LabelContext } from "../../core/label.context";
import {RESTContext} from "../../core/rest.context";
import {GeneralContext} from "../../core/general.context";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Slider from "react-slick";

type Promotion = {
    uuid: string;
    image: string;
    title: string;
    category?: string;
    url: string
};

type Coupon = {
    code: string;
    cartDiscountName: string;
    cartDiscountDescription: string;
    maxApplications?: number;
    validFrom: string
    validUntil: string
};

export const Promotions = (props: any) => {
    const { t } = React.useContext(LabelContext);
    const {ajaxMiddleware$, ajaxBRX$, token} = React.useContext(RESTContext)
    const { userData } = React.useContext(GeneralContext)
    const [coupons, setCoupons] = React.useState<Coupon[]>([]);

    const [promotions, setPromotions] = React.useState<Promotion[] | null>(null);

    React.useEffect(() => {
        ajaxBRX$(calls.Project.getPromotions()).subscribe(res => {
            setPromotions(res.promotions)
        })
        const body = {
            language: PROJECT_LANGUAGE,
            projectKey: PROJECT_KEY,
            authToken: token?.access_token,
            customerEmail: userData.email
        }
        ajaxMiddleware$(calls.Project.getActiveCouponInfo(), undefined, body).subscribe(
            res => {
                if (Array.isArray(res?.result)) {
                    setCoupons(res.result)
                } else {
                    setCoupons([])
                }
            }, error => {
                setCoupons([])
            }
        )
    }, []);

    const sliderSettings = {
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    swipe: true
                }
            },
            {
                breakpoint: 9999,
                settings: "unslick"
            }
        ]
    }

    return (
        <StyledPromotions>
            <Box className="unboxed secondary unbordered">

                {coupons && coupons.length > 0 && (
                    <>
                        <h2>
                            {t("ecommerce.myaccount.coupon-title-section")}
                        </h2>
                        <div className="pb-3">
                            {t("ecommerce.myaccount.coupon-subtitle-section")}
                        </div>

                        <div className="stories-grid mt-0 ml-0">
                            {coupons.map((c, i) => (
                                <div className="page-result" key={i}>
                                    <div className="product-content">

                                        {/* CODE in evidenza */}
                                        <div className="row pb-3">
                                            <div className="col-10">
                                                <h3>
                                                    {c.code}
                                                </h3>
                                            </div>
                                            <div className="col-2 text-right">
                                                <OverlayTrigger 
                                                    key={'overlay-'+i}
                                                    placement="auto"
                                                    overlay={
                                                        <Tooltip id={'tooltip-'+i}>
                                                            {c.cartDiscountDescription}
                                                        </Tooltip>
                                                    }>
                                                    <img src={`${BRX_ASSETS_URL}/images/icons/ecommerce/icon-info.svg`}></img>
                                                </OverlayTrigger>
                                            </div>
                                        </div>

                                        {/* NAME come sottotitolo meno importante */}
                                        {c.cartDiscountName && (
                                            <p>
                                                {c.cartDiscountName}
                                            </p>
                                        )}

                                        <div style={{ marginTop: "auto", fontSize: "0.9rem" }}>
                                            {c.validUntil && (
                                                <div>
                                                    <b>{t("ecommerce.myaccount.coupon-valid-until")}:</b>{" "}
                                                    {new Date(c.validUntil).toLocaleDateString()}
                                                </div>
                                            )}

                                            {c.maxApplications && (
                                                <div>
                                                    <b>{t("ecommerce.myaccount.coupon-max-applications")}:</b>{" "}
                                                    {c.maxApplications}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {coupons && coupons.length === 0 && (
                    <>
                        <h2 style={{ marginTop: "3rem" }}>
                            {t("ecommerce.myaccount.coupon-title-section")}
                        </h2>
                        <div className="empty-state text-center mt-3">
                            <p>{t("ecommerce.myaccount.coupon-empty-message")}</p>
                        </div>
                    </>
                )}

                <h2 style={{ marginTop: "3rem" }}>{t("ecommerce.myaccount.promotion-title-section")}</h2>

                {promotions && promotions.length > 0 && (
                    <Slider className="grid stories-grid js-stories-grid mt-0" {...sliderSettings}>
                        {promotions.map((p) => (
                            <div className="promotion js-storyItem stories-grid__item has-edit-button" key={p.uuid}>
                                <a href={`${p.url}`} className="text-decoration-none">
                                    <div className="storyItem__borderBlock">
                                        <div className="storyItem__image">
                                            <img src={p.image} alt={p.title} />
                                        </div>
                                        <div className="storyItem__textBlock">
                                            <div className="promotion__label">{t("promotionLabel")}</div>
                                            <div className="storyItem__title">{p.title}</div>
                                            <div className="promotion__category">{p.category}</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                )}

                {(!promotions || promotions.length === 0) && (
                    <div className="empty-state text-center">
                        <p>{t("ecommerce.myaccount.promotions-empty-message")}</p>
                    </div>
                )}
            </Box>
        </StyledPromotions>
    );
};


